import { getNumberOfUnits } from '../../common/utils/baggageUtils';
export const getNumberOfUnitsCabinBaggage = (name, form) => state => getNumberOfUnits(name, form)(state);
//# sourceMappingURL=units.js.map